export const PROFILE = {
  firstName: 'Khadija',
  lastName: 'Hammoud',
  location: 'Cairo, Egypt',
  openToRemote: 'Open to remote work',
};
